import {
  CULTURAL_EDIT_CATEGORY_REQUEST,
  CULTURAL_EDIT_CATEGORY_SUCCESS,
  CULTURAL_EDIT_CATEGORY_FAIL,
} from "../actionTypes";

const initialState = {
  loading: false,
  error: null,
};

export const culturalEditCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CULTURAL_EDIT_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case CULTURAL_EDIT_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        updatedCategory: action.payload,
      };
    case CULTURAL_EDIT_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default culturalEditCategoryReducer;
